import React from "react"; //llamado para creacion de componentes
import { Modal, Button } from "react-bootstrap"; //llamado para creacion de componentes de Bootstrap

export class ModalGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: this.props.show,
    };
  }

  handleHide(e, callback) {
    e ? e.preventDefault() : null;
    this.setState({ showModal: false }, callback ? callback() : null);
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    let params = this.props.getModalData ? this.props.getModalData() : {};
    return (
      <div id="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.props.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>
                {this.props.MessageTitle || params.titleModal}
              </Modal.Title>
              <Button
                className={(this.props.NoX || params.noX) + ""}
                onClick={(e) => this.handleHide(e, this.props.CloseAction)}
              >
                <i className="fa fa-times"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 left-error-modal">
                  <i
                    className={
                      (this.props.Icono || params.iconoModal) +
                      " " +
                      (this.props.colorIco || params.colorIco) +
                      " icon-error-modal"
                    }
                  ></i>
                </div>
                <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 right-error-modal">
                  <h4>{this.props.msg || params.messageModal}</h4>
                </div>
              </div>
              <div className="inner-Model-buttons">
                {this.props.MainButtonText &&
                  <Button
                    className={
                      (this.props.NoAceptar || params.noAceptar) +
                      " btn btn-primary btn-si btn-left"
                    }
                    onClick={(e) =>
                      this.handleHide(e, this.props.MainButtonAction)
                    }
                  >
                    {this.props.MainButtonText}
                  </Button>
                }
                {this.props.AltButtonText &&
                  <Button
                    className={
                      (this.props.NoCancelar || params.noCancelar) +
                      " btn btn-default btn-no btn-right"
                    }
                    onClick={(e) =>
                      this.handleHide(e, this.props.AltButtonAction)
                    }
                  >
                    {this.props.AltButtonText || params.AltButtonText}
                  </Button>
                }
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ModalGeneral;
